module.exports = __webpack_public_path__ + "static/media/400175_01.ab70916a.png";